export default "<div class=\"container\">\n    <p>panel control!</p>\n</div>";